// @flow

import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import PrettyNumber from 'app/common/react/i18n/PrettyNumber';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';

type Props = {|
  allDigits?: boolean,
  count: number,
|};

export default function TriedCount({ allDigits = true, count: triedCount }: Props) {
  return (
    <span>
      {interpolateNamedTemplate(
        i18n.ngettext(
          '{{ triedCountFormat }} Tried',
          '{{ triedCountFormat }} Tried',
          triedCount,
          'Label for the number of pin tries a user has',
        ),
        {
          triedCountFormat: (
            <strong key="tried_count">
              <PrettyNumber
                value={triedCount}
                shortform={!allDigits}
                shortformMaximumFractionDigits={!allDigits ? 1 : undefined}
              />
            </strong>
          ),
        },
      )}
    </span>
  );
}
